// import moment from 'moment'
import moment from 'moment-timezone'
import EXIF from 'exif-js'

let baseUrl = '/api/'
if (process.env.NODE_ENV === 'development') {
  baseUrl = 'http://127.0.0.1:5000/api/'
  // baseUrl = 'https://intern-voice.dkl.douwa.tech/api/'
  // baseUrl = 'http://192.168.0.225:5000/api/'
}

//自行车问题分类
let sup1 = ["69327", "61839", "71082", "45956"]
//衣服问题分类
let sup2 = ["74968","25093","48044","49425","45106","45793","46638","45512","61939","46710","24743","76139","71269","67808","1100242","60985","76350","9026","77823","71332","70843","46606","45459","48980","68476","9536","25596","49863","26284","10099","95839","60986","72649","76175","45116","74672","75007","47372","60055","45080","9674","95561","72439","48303"]
//鞋子
let sup3 = ["72937","73682","72784","45219","62572","70453","48173","67991"]
// const variable
//

let CLOSE_CASE = [
{ value: '2', label: '产品设计 Design'},
{ value: '5', label: '物流包装 Logisitc'},
{ value: '3', label: '生产成品质量 FG assembly'},
{ value: '4', label: '生产零件质量 CPT'},
{ value: '6', label: '无法判断是否有质量问题 Cannot Define if quality issue'},
{ value: '1', label: '非质量问题 Non-quality issue'},
{ value: '7', label: '无效反馈 Invalid feedback'}
]
 

let SELL_PERIOD = [{value: 'Before Sales', label_cn: '售前问题', label: 'Before Sales'}, {value: 'After Sales', label_cn: '售后问题', label: 'After Sales'}]
let PACK =  [{ value: 'intact', label_cn: '包装完好', label: 'Package is Good' },{ value: 'worn', label_cn: '包装破损', label: 'Package is damaged' }]

let PROBLEM_TYPE = [
  {value: '2', label_cn: '轮组偏摆', label: '轮组偏摆', types: [2], vendor_code: 'all'},
  {value: '3', label_cn: '飞轮异响', label: '飞轮异响', types: [2], vendor_code: 'all'},
  {value: '4', label_cn: '开胶', label: '开胶', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '5', label_cn: '鞋面破损', label: '鞋面破损', types: [0,1,2,3,4,5,6,7,8], vendor_code: ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '6', label_cn: '大底破损', label: '大底破损', types: [0,1,2,3,4,5,6,7,8], vendor_code: ["72937","73682","72784","45219","62572","70453","48173","67991"]},

  {value: '7', label_cn: '清洁度', label: '清洁度', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '8', label_cn: '溢色', label: '溢色', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '9', label_cn: '不防水', label: '不防水', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '10', label_cn: '不舒适', label: '不舒适', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '11', label_cn: '不防滑', label: '不防滑', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},
  {value: '12', label_cn: '鞋带,锁扣问题', label: '鞋带,锁扣问题', types: [0,1,2,3,4,5,6,7,8], vendor_code:  ["72937","73682","72784","45219","62572","70453","48173","67991"]},

  {value: '1', label_cn: '其他', label: 'other', types: [0,1,2,3,4,5,6,7,8], vendor_code: 'all'}
]

let ACCESSORY = [{ value: 'accessory', label_cn: '无质量问题仅需配件为顾客提供服务', label: 'I only need accessories to meet the needs of customers' },{ value: 'next', label_cn: '我需要反馈质量问题', label: 'I need to provide feedback on quality issues' }]

// let REDEFINED_LINK = [{value: 'Appointed material or component', label_cn: '指定零部件或原材料', label: 'Appointed material or component'},{value: 'FG assembly or producing', label_cn: '成品组装或生产过程', label: 'FG assembly or producing'},{value: 'Logistic', label_cn: '物流运输过程', label: 'Logistic'},{value: 'Store assembly', label_cn: '门店组装', label: 'Store assembly'},{value: 'Store display and user try', label_cn: '门店展示、试用', label: 'Store display and user try'},{value: 'Other', label_cn: '其他', label: 'Other'}]
let REDEFINED_LINK = [{value: 'Appointed material or component', label_cn: '指定零配件或原材料', label: 'Appointed material or component'},{value: 'FG assembly or producing', label_cn: '成品组装/生产', label: 'FG assembly or producing'},{value: 'Logistic', label_cn: '物流运输', label: 'Logistic'},{value: 'Store assembly', label_cn: '门店组装、陈列', label: 'Store assembly'},{value: 'Store display and user try', label_cn: '顾客使用、意外', label: 'Store display and user try'},{value: 'Product Desgin', label_cn: '产品设计', label: 'Product Desgin'}]

let weeks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53]
let monthes = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

let ALL_COUNTRIES = [ {value: 'AE', label_cn: '阿联酋', label: 'UNITED EMIRATES'}, {value: 'AF', label_cn: '阿富汗', label: 'AFGHANISTAN'}, {value: 'AL', label_cn: '阿尔巴尼亚', label: 'ALBANIA'}, {value: 'AM', label_cn: '亚美尼亚', label: 'ARMENIA'}, {value: 'AO', label_cn: '安哥拉', label: 'ANGOLA'}, {value: 'AR', label_cn: '阿根廷', label: 'ARGENTINA'}, {value: 'AT', label_cn: '奥地利', label: 'AUSTRIA'}, {value: 'AU', label_cn: '澳大利亚', label: 'AUSTRALIA'}, {value: 'AZ', label_cn: '阿塞拜疆', label: 'AZERBAIJAN REPUBLIC'}, {value: 'BD', label_cn: '孟加拉', label: 'BANGLADESH'}, {value: 'BE', label_cn: '比利时', label: 'BELGIUM'}, {value: 'BF', label_cn: '布基纳法索', label: 'BURKINA FASO'}, {value: 'BG', label_cn: '保加利亚', label: 'BULGARIA'}, {value: 'BH', label_cn: '巴林', label: 'BAHREIN'}, {value: 'BI', label_cn: '布隆迪', label: 'BURUNDI'}, {value: 'BJ', label_cn: '贝宁', label: 'BENIN'}, {value: 'BL', label_cn: '巴勒斯坦', label: ''}, {value: 'BN', label_cn: '文莱', label: 'BRUNEI DARUSSALAM'}, {value: 'BO', label_cn: '玻利维亚', label: 'BOLIVIA'}, {value: 'BR', label_cn: '巴西', label: 'BRAZIL'}, {value: 'BW', label_cn: '博茨瓦纳', label: 'BOTSWANA'}, {value: 'BY', label_cn: '白俄罗斯', label: 'BYELORUSSIA'}, {value: 'CA', label_cn: '加拿大', label: 'CANADA'}, {value: 'CF', label_cn: '中非', label: 'CENTRAL AFRICA'}, {value: 'CG', label_cn: '刚果', label: 'CONGO'}, {value: 'CH', label_cn: '瑞士', label: 'SWITZERLAND'}, {value: 'CL', label_cn: '智利', label: 'CHILE'}, {value: 'CM', label_cn: '喀麦隆', label: 'CAMEROON'}, {value: 'CN', label_cn: '中国', label: 'CHINA'}, {value: 'CO', label_cn: '哥伦比亚', label: 'COLOMBIA'}, {value: 'CR', label_cn: '哥斯达黎加', label: 'COSTA RICA'}, {value: 'CS', label_cn: '捷克', label: 'CZECH REPUBIC'}, {value: 'CU', label_cn: '古巴', label: 'CUBA'}, {value: 'CY', label_cn: '塞浦路斯', label: 'CYPRUS'}, {value: 'DE', label_cn: '德 国', label: 'GERMANY'}, {value: 'DK', label_cn: '丹麦', label: 'DENMARK'}, {value: 'DO', label_cn: '多米尼加共和国', label: 'DOMINICAN REPUBLIC'}, {value: 'DZ', label_cn: '阿尔及利亚', label: 'ALGERIA'}, {value: 'EC', label_cn: '厄瓜多尔', label: 'ECUADOR'}, {value: 'EE', label_cn: '爱沙尼亚', label: 'ESTONIA'}, {value: 'EG', label_cn: '埃及', label: 'EGYPT'}, {value: 'ES', label_cn: '西班牙', label: 'SPAIN'}, {value: 'ET', label_cn: '埃塞俄比亚', label: 'ETHIOPIA'}, {value: 'FI', label_cn: '芬兰', label: 'FINLAND'}, {value: 'FJ', label_cn: '斐济', label: 'FIJI'}, {value: 'FR', label_cn: '法国', label: 'FRANCE'}, {value: 'GA', label_cn: '加蓬', label: 'GABON'}, {value: 'GB', label_cn: '英国', label: 'UNITED KINGDOM'}, {value: 'GD', label_cn: '格林纳达', label: 'GRENADA'}, {value: 'GE', label_cn: '格鲁吉亚', label: 'GEORGIA'}, {value: 'GH', label_cn: '加纳', label: 'GHANA'}, {value: 'GN', label_cn: '几内亚', label: 'GUINEA'}, {value: 'GR', label_cn: '希腊', label: 'GREECE'}, {value: 'GT', label_cn: '危地马拉', label: 'GUATEMALA'}, {value: 'HK', label_cn: '香港特别行政区', label: 'HONG KONG'}, {value: 'HN', label_cn: '洪都拉斯', label: 'HONDURAS'}, {value: 'HU', label_cn: '匈牙利', label: 'HUNGARY'}, {value: 'ID', label_cn: '印度尼西亚', label: 'INDONESIA'}, {value: 'IE', label_cn: '爱尔兰', label: 'IRELAND'}, {value: 'IL', label_cn: '以色列', label: 'ISRAEL'}, {value: 'IN', label_cn: '印度', label: 'INDIA'}, {value: 'IQ', label_cn: '伊拉克', label: 'IRAQ'}, {value: 'IR', label_cn: '伊朗', label: 'IRAN'}, {value: 'IS', label_cn: '冰岛', label: 'ICELAND'}, {value: 'IT', label_cn: '意大利', label: 'ITALY'}, {value: 'JM', label_cn: '牙买加', label: 'JAMAICA'}, {value: 'JO', label_cn: '约旦', label: 'JORDAN'}, {value: 'JP', label_cn: '日本', label: 'JAPAN'}, {value: 'KG', label_cn: '吉尔吉斯坦', label: 'KYRGYZSTAN'}, {value: 'KH', label_cn: '柬埔寨', label: 'KAMPUCHEA CAMBODIA'}, {value: 'KP', label_cn: '北朝鲜', label: 'KOREA,DEM.PEOPLE’S'}, {value: 'KR', label_cn: '韩国', label: 'REPUBLIC OF KOREA'}, {value: 'KT', label_cn: '科特迪瓦共和国', label: 'COTE O’IVOIRE'}, {value: 'KW', label_cn: '科威特', label: 'KUWATI'}, {value: 'KZ', label_cn: '哈萨克', label: 'KAZAKHSTAN'}, {value: 'LA', label_cn: '老挝', label: 'LAOS'}, {value: 'LB', label_cn: '黎巴嫩', label: 'LEBANON'}, {value: 'LC', label_cn: '圣卢西亚', label: 'SAINT LUEIA'}, {value: 'LI', label_cn: '列支敦士登', label: 'LIECHTENSTEIN'}, {value: 'LK', label_cn: '斯里兰卡', label: 'SRI LANKA'}, {value: 'LR', label_cn: '利比里亚', label: 'LIBERIA'}, {value: 'LT', label_cn: '立陶宛', label: 'LITHUANIA'}, {value: 'LU', label_cn: '卢森堡', label: 'LUXEMBOURG'}, {value: 'LV', label_cn: '拉脱维亚', label: 'LATVIA'}, {value: 'LY', label_cn: '利比亚', label: 'LIBYAN'}, {value: 'MA', label_cn: '摩洛哥', label: 'MOROCCO'}, {value: 'MC', label_cn: '摩纳哥', label: 'MONACO'}, {value: 'MD', label_cn: '摩尔多瓦', label: 'MOLDOVA,REPUBLIC OF'}, {value: 'MG', label_cn: '马达加斯加', label: 'MADAGASCAR'}, {value: 'ML', label_cn: '马里', label: 'MALI'}, {value: 'MM', label_cn: '缅甸', label: 'BURMA MYANMAR'}, {value: 'MN', label_cn: '蒙古', label: 'MONGOLIA'}, {value: 'MO', label_cn: '澳门地区', label: 'MACAU'}, {value: 'MT', label_cn: '马耳他', label: 'MALTA'}, {value: 'MU', label_cn: '毛里求斯', label: 'MAURITIUS'}, {value: 'MW', label_cn: '马拉维', label: 'MALAWI'}, {value: 'MX', label_cn: '墨西哥', label: 'MEXICO'}, {value: 'MY', label_cn: '马来西亚', label: 'MALAYSIA'}, {value: 'MZ', label_cn: '莫桑比克', label: 'MOZAMBIQUE'}, {value: 'NA', label_cn: '纳米比亚', label: 'NAMIBIA'}, {value: 'NE', label_cn: '尼日尔', label: 'NIGER'}, {value: 'NG', label_cn: '尼日利亚', label: 'NIGERIA'}, {value: 'NI', label_cn: '尼加拉瓜', label: 'NICARAGUA'}, {value: 'NL', label_cn: '荷兰', label: 'NETHERLANDS'}, {value: 'NO', label_cn: '挪威', label: 'NORWAY'}, {value: 'NP', label_cn: '尼泊尔', label: 'NEPAL'}, {value: 'NZ', label_cn: '新西兰', label: 'NEW ZEALAND'}, {value: 'OM', label_cn: '阿曼', label: 'OMAN'}, {value: 'PA', label_cn: '巴拿马', label: 'PANAMA'}, {value: 'PE', label_cn: '秘鲁', label: 'PERU'}, {value: 'PG', label_cn: '巴布亚新几内亚', label: 'PAPUA NEW GUINEA'}, {value: 'PH', label_cn: '菲律宾', label: 'PHILIPPINES'}, {value: 'PK', label_cn: '巴基斯坦', label: 'PAKISTAN'}, {value: 'PL', label_cn: '波兰', label: 'POLAND'}, {value: 'PT', label_cn: '葡萄牙', label: 'PORTUGAL'}, {value: 'PY', label_cn: '巴拉圭', label: 'PARAGUAY'}, {value: 'QA', label_cn: '卡塔尔', label: 'QATAR'}, {value: 'RO', label_cn: '罗马尼亚', label: 'ROMANIA'}, {value: 'RU', label_cn: '俄罗斯', label: 'RUSSIAN FEDERATION'}, {value: 'SA', label_cn: '沙特阿拉伯', label: 'SAUDI ARABIA'}, {value: 'SC', label_cn: '塞舌尔', label: 'SEYCHELLES'}, {value: 'SD', label_cn: '苏丹', label: 'SUDAN'}, {value: 'SE', label_cn: '瑞典', label: 'SWEDEN'}, {value: 'SG', label_cn: '新加坡', label: 'SINGAPORE'}, {value: 'SI', label_cn: '斯洛文尼亚', label: 'SLOVENIA'}, {value: 'SK', label_cn: '斯洛伐克', label: 'SLOVAKIA'}, {value: 'SM', label_cn: '圣马力诺', label: 'SAN MARINO'}, {value: 'SN', label_cn: '塞内加尔', label: 'SENEGAL'}, {value: 'SO', label_cn: '索马里', label: 'SOMALIA'}, {value: 'SY', label_cn: '叙利亚', label: 'SYRIA'}, {value: 'SZ', label_cn: '斯威士兰', label: 'SWAZILAND'}, {value: 'TD', label_cn: '乍得', label: 'CHAD'}, {value: 'TG', label_cn: '多哥', label: 'TOGO'}, {value: 'TH', label_cn: '泰国', label: 'THAILAND'}, {value: 'TJ', label_cn: '塔吉克斯坦', label: 'TAJIKISTAN'}, {value: 'TM', label_cn: '土库曼', label: 'TURKMENISTAN'}, {value: 'TN', label_cn: '突尼斯', label: 'TUNISIA'}, {value: 'TR', label_cn: '土耳其', label: 'TURKEY'}, {value: 'TW', label_cn: '台湾省', label: 'TAIWAN'}, {value: 'TZ', label_cn: '坦桑尼亚', label: 'TANZANIA'}, {value: 'UA', label_cn: '乌克兰', label: 'UKRAINE'}, {value: 'UG', label_cn: '乌干达', label: 'UGANDA'}, {value: 'US', label_cn: '美国', label: 'UNITED STATES'}, {value: 'UY', label_cn: '乌拉圭', label: 'URUGUAY'}, {value: 'UZ', label_cn: '乌兹别克', label: 'UZBEKISTAN'}, {value: 'VC', label_cn: '圣文森特岛', label: 'SAINT VINCENT'}, {value: 'VE', label_cn: '委内瑞拉', label: 'VENEZUELA'}, {value: 'VN', label_cn: '越南', label: 'VIET NAM'}, {value: 'YE', label_cn: '也门', label: 'YEMEN'}, {value: 'YU', label_cn: '南斯拉夫联盟', label: 'YUGOSLAVIA'}, {value: 'ZA', label_cn: '南非', label: 'SOUTH AFRICA'}, {value: 'ZM', label_cn: '赞比亚', label: 'ZAMBIA'}, {value: 'ZR', label_cn: '扎伊尔', label: 'ZAIRE'}, {value: 'ZW', label_cn: '津巴布韦', label: 'ZIMBABWE'} ]

function years () {
  let years = []
  let thisYear = new Date().getFullYear()

  for (let i = thisYear; i >= 1900; i--) {
    years.push(i)
  }
  return years
}

let c = {
  FeedbackFollowsFalse: {
    name: 'star_border',
    color: 'grey',
    label: 'FOLLOW'
  },
  FeedbackFollowsTrue: {
    name: 'star',
    color: 'orange',
    label: 'UNFOLLOW'
  },
  ProblemCategorys2: [{
    label: 'Dedicated channel for customer injuries',
    label_cn: '顾客受伤专用通道',
    value: 'wound',
    name: 'Wound',
    color:"red",
    //remark: '此问题涉及客户安全，<b><font color="red">造成客户受伤</font></b>，紧急程度很高',
    //remark_en: 'This problem concerns customer safety with <b><font color="red">risk of hurting customers</font></b>, very urgent'
  },
  {
    label: 'Customer allergy dedicated channel',
    label_cn: '顾客过敏专用通道',
    value: 'allergy',
    name: 'Allergy',
    color:"purple",
    //remark: '此问题涉及产品功能使用缺陷，如球漏气，衣服破洞等，紧急程度中',
    //remark_en: 'This problem concerns the function of the product, such as a flat ball or hole in clothes, middle urgent'
  },
  {
    label: 'Other quality issues',
    label_cn: '其他质量问题',
    value: 'other',
    name: 'Other',
    color:"blue",
    //remark: '此问题涉及产品外观，但并不影响产品使用，如衣服发黄，自行车掉漆等，紧急程度低',
    //remark_en: 'This problem concerns products appearance, but won’t affect final use of the product, such as yellowing clothes or bicycle paint off, low urgent'
  }],
  ProblemCategorys: [{
    label: 'Safety',
    label_cn: '安全问题',
    value: 'safety',
    name: 'Safety',
    remark: '此问题涉及客户安全，<b><font color="red">造成客户受伤</font></b>，紧急程度很高',
    remark_en: 'This problem concerns customer safety with <b><font color="red">risk of hurting customers</font></b>, very urgent'
  },
  {
    label: 'Function',
    label_cn: '功能问题',
    value: 'function',
    name: 'Function',
    remark: '此问题涉及产品功能使用缺陷，如球漏气，衣服破洞等，紧急程度中',
    remark_en: 'This problem concerns the function of the product, such as a flat ball or hole in clothes, middle urgent'
  },
  {
    label: 'Appearance',
    label_cn: '外观问题',
    value: 'appearance',
    name: 'Appearance',
    remark: '此问题涉及产品外观，但并不影响产品使用，如衣服发黄，自行车掉漆等，紧急程度低',
    remark_en: 'This problem concerns products appearance, but won’t affect final use of the product, such as yellowing clothes or bicycle paint off, low urgent'
  },
  {
    label: 'Legal',
    label_cn: '法律问题',
    value: 'legal',
    name: 'Legal',
    remark: '此问题涉及法律法规，产品标签标识，需同时报备零售法务，紧急程度很高',
    remark_en: 'This problem concerns legal or conformity problem on the product, such as wrong information on the label, please report to legal team too, very urgent'
  }],
  FeedbackRoles: [{
    label: 'I am from store',
    label_cn: '我来自门店',
    value: 'store',
    name: 'Store'
  },
  {
    label: 'I am from warehouse',
    label_cn: '我来自仓库',
    value: 'warehouse',
    name: 'Warehouse'
  },
  {
    label: 'I am a normal user of the product or from other BU',
    label_cn: '我是该产品的使用者或者来自其他部门',
    value: 'normal_user',
    name: 'normal_user'
  }],
  TreatmentPlans: [{
    label: 'Discount',
    label_cn: '打折销售',
    value: 'discount',
    name: 'Discount',
    roles: ['store']
  },
  {
    label: 'Return to warehouse',
    label_cn: '退回仓库',
    value: 'sendback',
    name: 'Return',
    roles: ['store']
  },
  {
    label: 'Repair',
    label_cn: '门店自行维修',
    value: 'repair',
    name: 'Repair',
    roles: ['store']
  },
  {
    label: 'Defective',
    label_cn: '此产品为客户退回的情况下选择',
    value: 'defect',
    name: 'Defective',
    roles: ['store']
  },
  {
    label: 'Decote',
    label_cn: '店内decote销毁',
    value: 'deco',
    name: 'Decote',
    roles: ['store']
  },
  {
    label: 'Destruction and IP',
    label_cn: '销毁后-IP',
    value: 'dest_ip',
    name: 'Destruction',
    roles: ['warehouse']
  },
  {
    label: 'I don’t know, ask for help',
    label_cn: '我不知道如何处理，请求支援',
    value: 'help',
    name: 'Help',
    roles: ['store', 'warehouse']
  },
  {
    label: 'I just want to report the issue',
    label_cn: '我仅仅想要反馈这个问题',
    value: 'report',
    name: 'Report',
    roles: ['normal_user']
  },
  {
    label: 'I want to be contacted for further investigation of the problem',
    label_cn: '我希望被联系到，进一步调查该问题',
    value: 'contacted',
    name: 'Want to Contacted',
    roles: ['normal_user']
  },
  {
    label: 'Other',
    label_cn: '其他',
    value: 'other',
    name: 'Other',
    roles: ['store', 'warehouse']
  }],
  // 语言值
  LanguageItem: [
    {
      label: 'English',
      value: 'en',
      name: 'en',
      label_cn: '英语'
    },
    {
      label: '简体中文',
      value: 'zh_cn',
      name: 'zh_cn',
      label_cn: '简体中文'
    }
  ],
  CustomerInjuryStatus: [
    {
      label_en: 'Minor',
      value: 'minor',
      label_cn: '轻微'
    },
    {
      label_en: 'Severe',
      value: 'severe',
      label_cn: '严重'
    },
    {
      label_en: 'Causing Death',
      value: 'causing death',
      label_cn: '导致死亡'
    }
  ],
  RetailLegal: [
    {
      label_en: 'YES',
      value: 'yes',
      label_cn: '是'
    },
    {
      label_en: 'NO',
      value: 'no',
      label_cn: '否'
    }
  ],
  AllRetailLegal:[
    {
      label_en: 'ALL',
      value: 'all',
      label_cn: '所有 ALL'
    },
    {
      label_en: 'YES',
      value: 'yes',
      label_cn: '是 YES only'
    },
    {
      label_en: 'NO',
      value: 'no',
      label_cn: "否 I don't need this notification"
    }
  ],
}

// api url
let api = {
  product: baseUrl + 'product/',
  feedback: baseUrl + 'feedback/',
  subscribe: baseUrl + 'subscribe/',
  attribute: baseUrl + 'attribute/',
  questionnaire: baseUrl + 'questionnaire/',
  oauth: baseUrl + 'oauth/',
  auth: baseUrl + 'auth/',
  tools: baseUrl + 'tools/',
  storeAddress: baseUrl + 'storeAddress/',
  permission: baseUrl + 'permission/',
  internVoiceFeedback: baseUrl + 'internVoiceFeedback/',
  feedbackFollow: baseUrl + 'feedback_follow/',
  vendor: baseUrl + 'vendor/',
  excel: baseUrl + 'excel/',
  internVoice: baseUrl + 'intern_voice/',
  // files: baseUrl + 'files/'
  files: 'https://intern-voice.dkl.douwa.tech/api/' + 'files/'
  // files: 'http://192.168.0.225:5000/api/' + 'files/'
  // files: 'http://47.110.154.127:30854/api/' + 'files/'
}

let pickerOptions = {
  shortcuts: [{
    text: '本周',
    onClick (picker) {
      let start = moment().startOf('week')
      let end = moment().endOf('week')
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '上周',
    onClick (picker) {
      let start = moment().startOf('week').subtract('week', 1)
      let end = moment().endOf('week').subtract('week', 1)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '本月',
    onClick (picker) {
      let start = moment().startOf('month')
      let end = moment().endOf('month')
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '上月',
    onClick (picker) {
      let start = moment().startOf('month').subtract('month', 1)
      let end = moment().endOf('month').subtract('month', 1).endOf('month')
      picker.$emit('pick', [start, end])
    }
  }]
}

function formatProblemCategory (value) {
  for (let index in c.ProblemCategorys) {
    let item = c.ProblemCategorys[index]
    if (item.value === value) {
      return item.name
    }
  }
}

function formatredefineProblemCategorys (value) {
  for (let index in c.redefineProblemCategorys) {
    let item = c.redefineProblemCategorys[index]
    if (item.value === value) {
      return item.name
    }
  }
}

function formatTreatmentPlan (value) {
  for (let index in c.TreatmentPlans) {
    let item = c.TreatmentPlans[index]
    if (item.value === value) {
      return item.name
    }
  }
}

function formatSalePeriod (value) {
  for (let index in SELL_PERIOD) {
    let item = SELL_PERIOD[index]
    if (item.value === value) {
      return item.name
    }
  }
}

let storage = {
  // set_profile (profile) {
  //   Vue.localStorage.set('profile', JSON.stringify(profile))
  // },
  // get_profile () {
  //   let profile = Vue.localStorage.get('profile', undefined)
  //   if (profile) {
  //     profile = JSON.parse(profile)
  //   }
  //   return profile
  // },
  // remove_profile () {
  //   Vue.localStorage.remove('profile')
  // },
  set_user_level (level) {
    localStorage.setItem('user_level', level)
  },
  set_token (token) {
    localStorage.setItem('token', token)
  },
  get_token () {
    let token = localStorage.getItem('token', undefined)
    return token
  },
  remove_token () {
    localStorage.removeItem('token')
  },
  remove_user_level () {
    localStorage.removeItem('user_level')
  }
}

function formatToDate (createdTime) {
  // return moment(createdTime).format('YYYY-MM-DD')
  return moment.utc(createdTime).tz('Asia/Shanghai').format('YYYY-MM-DD')
}

function formatToTime (createdTime) {
  return moment.utc(createdTime).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss')
  // return moment.utc(createdTime).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')
}

function formatTime (createdTime, formatStr) {
  return moment.utc(createdTime).tz('Asia/Shanghai').format(formatStr)
}

function convertImgToBase64URL (url, callback, outputFormat) {
  let img = new Image()
  img.crossOrigin = 'Anonymous'
  img.onload = function () {
    let canvas = document.createElement('CANVAS'),
      ctx = canvas.getContext('2d'), dataURL
    canvas.height = img.height / 15
    canvas.width = img.width / 15
    ctx.drawImage(img, 0, 0, canvas.height, canvas.width)
    dataURL = canvas.toDataURL(outputFormat)
    callback(dataURL)
    canvas = null
  }
  img.src = url
}

function hasBackendPermission () {
  // 判断是否有后台权限
  if (localStorage.getItem('user_level') > PERMISSION_VALUE.END_LEVEL) {
    return false
  } else {
    return true
  }
}

let iosRotateImg = {

  getOrientation: function (file) {
    // 获取拍摄角度参数
    return new Promise((resolve) => {
      EXIF.getData(file, function () {
        const orient = EXIF.getTag(this, 'Orientation')
        resolve(orient)
      })
    })
  },

  dataURLtoFile: function (dataurl, filename) {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, {type: mime})
  },

  rotateImage: function (image, width, height) {
    // 旋转照片
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    ctx.save()
    canvas.width = height
    canvas.height = width
    ctx.rotate(90 * Math.PI / 180)
    ctx.drawImage(image, 0, -height)
    ctx.restore()
    return canvas.toDataURL('image/jpeg', 0.5)
  }
}

// 权限值
let PERMISSION_VALUE = {
  // >=10，只有前端权限
  FRONT_LEVEL: 10,
  // <=5有后端权限
  END_LEVEL: 5,
  // <=4 有Questionnaire权限
  QUES_LEVEL: 4,
  // <=3 有地址和title管理权限
  ADMIN_LEVEL: 3,
  // 超级权限
  SUPER_LEVEL: 0
}

function showTag (feedback) {
    if (feedback.problem_category === "wound") {
      return "受伤 Injured"
    } else if (feedback.problem_category === "allergy") {
      return "过敏 Allergy"
    } else if (feedback.is_decathlon === false) {
      return "AMI"
    } else if (feedback.is_overseas === true) {
      return "海外 Overseas supplier"
    } else if (feedback.problem_category === "logistic") {
      return "Record - Logistic"
    } else if (feedback.problem_category === "lcare") {
      return "Record - lcare"
    } else if (feedback.problem_category === "spareparts") {
      return "Record - Spareparts"
    } else {
      return "Quality feedback"
    }
}

let TAG = [
{ value: 'all', label: '全部 ALL'},
{ value: 'wound', label: '受伤 Injured'},
{ value: 'allergy', label: '过敏 Allergy'},
{ value: 'ami', label: 'AMI'},
{ value: 'overseas', label: '海外 Overseas supplier'},
{ value: 'logistic', label: 'Record - Logistic'},
// { value: 'lcare', label: 'Record - lcare'},
// { value: 'spareparts', label: 'Record - Spareparts'},
{ value: 'other', label: 'Quality feedback'}
]

let TAGFILTER = [
{ value: 'all', label: '全部 ALL'},
{ value: 'wound', label: '受伤 Injured'},
{ value: 'allergy', label: '过敏 Allergy'},
{ value: 'logistic', label: 'Record - Logistic'},
// { value: 'lcare', label: 'Record - lcare'},
// { value: 'spareparts', label: 'Record - Spareparts'},
{ value: 'other', label: 'Quality feedback'}
//{ value: 'quality', label: 'Quality feedback'}
]

function deepCopy (target) {
  // 定义一个变量
  let result
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === 'object') {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      // 将result赋值为一个数组，并且执行遍历
      result = []
      for (const i in target) {
        // 递归克隆数组中的每一项
        result.push(deepCopy(target[i]))
      }
    // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null
    // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target
    } else if (target.constructor === Date) {
      result = new Date(target)
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {}
      for (const i in target) {
        result[i] = deepCopy(target[i])
      }
    }
  // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target
  }

  // 返回最终结果
  return result
}



export default {
  // const variable
  c,
  // api url
  api,
  pickerOptions,
  iosRotateImg,
  formatProblemCategory,
  formatTreatmentPlan,
  formatSalePeriod,
  storage,
  formatToDate,
  formatToTime,
  formatTime,
  weeks,
  monthes,
  years,
  PERMISSION_VALUE,
  convertImgToBase64URL,
  ALL_COUNTRIES,
  REDEFINED_LINK,
  SELL_PERIOD,
  PACK,
  ACCESSORY,
  hasBackendPermission,
  PROBLEM_TYPE,
CLOSE_CASE,
  showTag,
TAG,
TAGFILTER,
deepCopy,
sup1,
sup2,
sup3,
}



// WEBPACK FOOTER //
// ./src/utils/index.js